import { styled } from '@mui/material/styles';
import { Add, FormatListBulleted, GridViewRounded } from "@mui/icons-material";
import { Button, ButtonBase, Grid, ListItemIcon, MenuItem, Pagination, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useEffect, useState } from "react";
import BgBox from "../../../components/BgBox";
import { customAlert } from "../../../components/notify";
import ScrollBox from "../../../components/ScrollBox";
import { getAllTrkOpReqWPagSrch } from "../../../services/req_service";
import { FaSortAmountDownAlt, FaSortAmountDown } from 'react-icons/fa';
import CustomDropDown from '../../../components/CustomDropDown';
import route from '../../../Routes';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import TrkOpReqCard from '../../../components/TrkOpReqCard';
import TrkOpReqTable from '../../../components/TrkOpReqTable';
import { useTranslation } from "react-i18next";
import { useQuery } from 'react-query';
import QueryKey from '../../../QueryKey';
import LoadingScreen from '../../../components/loadingScreen';
import MissingPage from '../../MissingPage';
import { ArrowDropDown, ArrowDropUp, Description, PictureAsPdf } from '@mui/icons-material';
import { useAuthContext } from '../../../context/AuthContext';
import { genTrkOpReqRept } from '../../../services/pdf-service';
import { trkOpReqExel } from '../../../services/excel-service';
import OptionMenu from '../../../components/OptionMenu';
import SearchTxtFieldClr from '../../../components/SearchTxtFieldClr';
import { DEFAULT_PAGE_SIZE } from '../../../constants/pagination';
import { getAllReportConfigs } from '../../../services/bo-service';
import RecordCount from "../../../components/RecordCount";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  '& .MuiToggleButtonGroup-grouped': {
    // margin: theme.spacing(0.5),
    border: 0,
    '&.Mui-disabled': {
      border: 0,
    },
    '&:not(:first-of-type)': {
      borderRadius: theme.shape.borderRadius,
    },
    '&:first-of-type': {
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

function TrkOpReqListPage() {
  const { t } = useTranslation();
  const { time } = useParams();
  const ddArr = [
    { value: "name", label: t("bo.tpReqLstPg.dOperator"), },
    { value: "reqId", label: t("bo.tpReqLstPg.dReqId"), },
    { value: "mobile", label: t("bo.tpReqLstPg.dContact"), },
  ];
  const navigate = useNavigate();
  const limit = DEFAULT_PAGE_SIZE;
  const { setLoadingScreen, setLastSeenObjFn } = useAuthContext();

  // const [pageNumber, setPageNumber] = useState(1);
  // const [view, setView] = useState('list');
  // const [searchWord, setSearchWord] = useState("");
  // const [searchType, setSearchType] = useState(ddArr[0].value);
  // const [order, setOrder] = useState('desc');
  // const [searchKeyType, setSearchKeyType] = useState(ddArr[0].value);
  // const [searchKeyWord, setSearchKeyWord] = useState("");

  const [searchParams, setSearchParams] = useSearchParams();
  const pgNo = parseInt(searchParams.get("pgNo") || "1");
  const searchType = searchParams.get("st") || ddArr[0].value;
  const querySearchWord = searchParams.get("s") || "";
  const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
  const [isSrchBtnClick, setIsSrchBtnClick] = useState(0);
  const order = searchParams.get("order") || "desc";
  const view = searchParams.get("view") || "list";

  const [searchKeyWord, setSearchKeyWord] = useState(searchWord);
  const [searchKeyType, setSearchKeyType] = useState(searchType);

  const { isLoading, isError, error, data: trkOpReqRow } = useQuery(
    [QueryKey.trkOpReqList, pgNo, isSrchBtnClick, order, time],
    () => getAllTrkOpReqWPagSrch({ pageNumber: pgNo, limit, searchKeyWord: searchKeyWord, searchType: searchKeyType, order, time }), {
    keepPreviousData: true
  })

  const { data: trkOpReqCfgArr } = useQuery([QueryKey.reportConfigList, "trkOpReq"], () => getAllReportConfigs("trkOpReq"));

  useEffect(() => {
    if (time === "current") {
      setLastSeenObjFn('request');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const columns = [
    {
      id: 'truckOpReqId',
      label: t("bo.tpReqTable.reqId"),
      align: 'left',
      minWidth: 100
    },
    {
      id: 'name',
      label: t("bo.tpReqTable.trkOp"),
      align: 'left',
      minWidth: 100
    },
    {
      id: 'currLocation',
      label: t("bo.tpReqTable.loc"),
      align: 'left',
      minWidth: 120
    },
    {
      id: 'routes',
      label: t("bo.tpReqTable.route"),
      align: 'left',
      minWidth: 120
    },
    {
      id: 'availSpace',
      label: t("bo.tpReqTable.space"),
      align: 'left',
      minWidth: 100
    },
    {
      id: 'regNo',
      label: t("bo.trkInfoPg.trkNum"),
      align: 'left',
      minWidth: 100
    },
    {
      id: 'truckTypes',
      label: t("bo.tpReqTable.trk"),
      align: 'left',
      minWidth: 100
    },
    {
      id: 'createdShipmtCount',
      label: t("bo.custRqTable.createdShipmts"),
      align: 'left',
      minWidth: 50
    },
    {
      id: 'c_at',
      label: t("bo.tpReqTable.postedOn"),
      align: 'left',
      minWidth: 100
    },
    {
      id: 'options',
      label: '',
      // align: 'right',
      minWidth: 80
    },
  ];

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // SA-configured column set for Truck Request exports (falls back to the on-screen columns).
  const exportColumns = trkOpReqCfgArr?.[0]?.config ? JSON.parse(trkOpReqCfgArr[0].config) : columns;

  const optionItems = [
    {
      title: t("bo.reptListPg.pdf"),
      icon: <PictureAsPdf fontSize="small" />,
      fn: async () => {
        setLoadingScreen(true);
        try {
          const filterObj = {
            user: 'bo',
            time: time,
            reqType: "trkOp",
            ...(searchKeyWord && { searchKeyWord }),
            ...(searchType && { searchType: searchKeyType }),
            order
          }
          const res = await genTrkOpReqRept({ filterObj, columns: exportColumns });
          window.open(res.fileUrl, "_blank")
        } catch (err) {
          // console.log(err);
          customAlert(err)
        }
        setLoadingScreen(false);
      }
    },
    {
      title: t("bo.reptListPg.excel"),
      icon: <Description fontSize="small" />,
      fn: async () => {
        try {
          const filterObj = {
            user: 'bo',
            time: time,
            reqType: "trkOp",
            ...(searchKeyWord && { searchKeyWord }),
            ...(searchType && { searchType: searchKeyType }),
            order
          }
          const res = await trkOpReqExel({ filterObj, columns: exportColumns });
          window.open(res.fileUrl, "_blank")
        } catch (err) {
          // console.log(err);
          customAlert(err)
        }
      }
    }
  ]

  const handleExportClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setAnchorEl(null);
  };


  function onViewChange(e, v) {
    if (v == null)
      return

    setSearchParams(prev => {
      prev.set("view", 1)
      return prev
    }, { replace: true })
  }

  async function onOrderChange(e, or) {
    if (or == null)
      return

    setSearchParams(prev => {
      prev.set("pgNo", 1)
      prev.set("order", or)
      return prev
    }, { replace: true })
  }


  const handlePageChange = async (event, value) => {
    setSearchParams(prev => {
      prev.set("pgNo", value)
      return prev
    }, { replace: true })
  };

  async function onSearchBtnClick(e) {
    setSearchKeyWord(searchWord);
    setSearchKeyType(searchType);
    setIsSrchBtnClick((prevVal) => ++prevVal)
    setSearchParams(prev => {
      prev.set("pgNo", 1)
      return prev
    }, { replace: true })
  }

  function onSearch(e) {
    setSearchWord(e.target.value)
    setSearchParams(prev => {
      prev.set("s", encodeURIComponent(e.target.value))
      return prev
    }, { replace: true })
  }

  function handleDDChange(e) {
    setSearchParams(prev => {
      prev.set("st", e.target.value)
      return prev
    }, { replace: true })
  }

  function handleOnClear(e) {
    setIsSrchBtnClick((prevVal) => ++prevVal)
    setSearchWord("");
    setSearchKeyWord("")
    setSearchParams(prev => {
      prev.set("pgNo", 1)
      prev.set("s", "")
      return prev
    }, { replace: true })
  }

  function getSrchTypeTxt() {
    let filteredObj = ddArr.filter((i) => i.value === searchType);
    return filteredObj[0]?.label || "";
  }

  function handleCust() {
    navigate(route.boCustReqList + time);
  }

  async function handleAddReq() {
    navigate(route.boAddTrkOpReq);
  }

  if (isError) {
    customAlert(error);
    return <h2>Something went wrong</h2>
  }

  if (isLoading)
    return <Box sx={{ position: "absolute", top: 0, left: 0 }}><LoadingScreen /></Box>

  if (time !== "current" && time !== "history") {
    return <MissingPage />
  }


  return (
    <Box height={"100%"} width={"100%"}>
      <Stack direction={'row'} justifyContent='space-between' mb={1.5} >
        <Typography variant='h5' sx={{ fontWeight: "bold" }}>{time === "current" ? t("bo.tpReqLstPg.reqLstScrn") : t("bo.tpReqLstPg.reqHis")}<RecordCount count={trkOpReqRow?.totalLength} /></Typography>
        <Stack mr={5}>
          <Stack direction={'row'} mx={1} gap={2}>
            <ButtonBase component="div" onClick={handleCust}>  <Typography sx={{ fontWeight: "600", }}>{t("bo.tpReqLstPg.cust")}</Typography></ButtonBase>
            <ButtonBase component="div"> <Typography sx={{ fontWeight: "600", color: "primary.main" }}>{t("bo.tpReqLstPg.trkOp")}</Typography></ButtonBase>
          </Stack>
          <Box sx={{ width: 228, backgroundColor: "#E3E3E3", borderRadius: 10, height: 5, mt: 0.5 }}>
            <Stack direction={'row'} height={4}>
              <Box sx={{ width: 88, borderRadius: 10 }} />
              <Box sx={{ width: 140, borderRadius: 10, backgroundColor: "primary.main" }} />
            </Stack>
          </Box>
        </Stack>
      </Stack>

      <BgBox height={"95%"} px={4} py={1}>

        <Stack direction={'row'} justifyContent="space-between" alignItems={"center"} mb={1.2} mt={0.4} px={2}>
          <StyledToggleButtonGroup color="primary" size="small" value={view} exclusive onChange={onViewChange} sx={{ mb: 0.5, height: 36 }}>
            <ToggleButton value='list'>
              <FormatListBulleted /> <Typography sx={{ ml: 0.3, fontSize: 15 }}>{t("bo.tpReqLstPg.list")}</Typography>
            </ToggleButton>
            <ToggleButton value="center">
              <GridViewRounded /> <Typography sx={{ ml: 0.3, fontSize: 15 }}>{t("bo.tpReqLstPg.grid")}</Typography>
            </ToggleButton>
          </StyledToggleButtonGroup>

          <Stack direction={'row'} justifyContent="space-between" alignItems={"center"}>
            <Box mb={0.5}><SearchTxtFieldClr handleOnClear={handleOnClear} variant={"outlined"} searchKeyWord={searchWord} onSearch={onSearch} onBtnClick={onSearchBtnClick} placeholder={t("bo.tpReqLstPg.search") + ` ${getSrchTypeTxt()} .....`} /></Box>
            <CustomDropDown height={36} width={140} handleDDChange={handleDDChange} ddArr={ddArr} defaultValue={searchType} />

            <StyledToggleButtonGroup color="primary" size="small" value={order} exclusive onChange={onOrderChange} sx={{ mb: 0.5, height: 36, mx: 3 }}>
              <ToggleButton value='desc'>
                <Stack sx={{ fontSize: 18, justifyContent: "center", alignItems: "center" }}>  <FaSortAmountDown /></Stack>
              </ToggleButton>
              <ToggleButton value="asc">
                <Stack sx={{ fontSize: 18, justifyContent: "center", alignItems: "center" }}>  <FaSortAmountDownAlt /></Stack>
              </ToggleButton>
            </StyledToggleButtonGroup>

            <Button variant='contained' sx={{ height: 36, mb: 0.5 }} startIcon={<Add />} color='primary' onClick={handleAddReq}>{t("bo.tpReqLstPg.addReq")}</Button>
            <Button variant='contained' sx={{ ml: 2, mb: 0.4 }} endIcon={open ? <ArrowDropUp /> : <ArrowDropDown />} color='primary' onClick={handleExportClick} >{t("bo.reptListPg.export")}</Button>
          </Stack>
        </Stack>


        {view === 'list' ? <TrkOpReqTable trkOpReqRow={trkOpReqRow?.data} time={time} columns={columns} /> :
          <ScrollBox height={"84%"}>
            <Grid container spacing={1}
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              {trkOpReqRow?.data.map((i) => <Grid item xs="auto" key={i.id}> <TrkOpReqCard i={i} /> </Grid>)}
            </Grid>
          </ScrollBox>
        }

        <Stack sx={{ alignItems: "center", mt: 1 }}>
          <Pagination count={Math.ceil(trkOpReqRow?.totalLength / limit) || 0} color="primary" page={pgNo} onChange={handlePageChange} variant="outlined" shape="rounded" />
        </Stack>

      </BgBox>
      <OptionMenu open={open} handleClose={handleExportClose} anchorEl={anchorEl} >
        {optionItems.map((i) => <MenuItem sx={{ pl: 2, pr: 5 }} key={i.title} onClick={i.fn}>
          <ListItemIcon > {i.icon}</ListItemIcon>
          {i.title}
        </MenuItem>)}
      </OptionMenu>
    </Box>
  )
}

export default TrkOpReqListPage;